import { optionsToStrategy } from "@/common/utils/optionsToStrategy"

export const options = [
  {
    label: 'Senha aleatória gerada pelo sistema',
    value: 'random_only',
  },
  {
    label: 'Usuário pode escolher uma senha ou gerar automaticamente',
    value: 'default',
  },
]

export const strategy = optionsToStrategy(options)